import { ca } from "date-fns/locale";

const Colors = {
  whiteBackground: "#fff",
  primary: "#0091f9",
  lightPrimary: "#F8FAFC",
  lightBackground:"#e8f6ff",
  secondary: "#F9914E",
  text: "#5A5B61",
  blackText: "#18181B",
  placeholder: "#B1B1B1",
  fieldBorder: "#E2E2E2",
  shadow: "rgba(206, 206, 206, 0.16)",
  darkShadow: "rgba(206, 206, 206, 0.90)",
  success: "#04BD6C",
  successBackground: "##EDF9F0",
  error: "#D21D19",
  errorBackground: "#ffede9",
  pending: "#5A5B61",
  pendingBackground: "#F7F7FC",
  canceled: "#F9914E",
  canceledBackground: "#FFF3E8",
  approved: "#0091f9",
  approvedBackground: "#F8FAFC",
  messageBox: "#F7F7FC",
  blackBackground: "#18181B",
  gray: '#5A5B61',
  start: "#6D62F1",
  profit: "#665DDB",
  grayBackground: "#F8FAFC",
  readonlyBackground: "#f2f2f2",

};

const DarkColors = {
  whiteBackground: "#0091f9",
  primary: "#fff",
  lightPrimary: "#d3e5fc",
  secondary: "#F9914E",
  text: "#5A5B61",
  blackText: "#fff",
  placeholder: "#F8FAFC",
  fieldBorder: "#fff",
  shadow: "rgba(206, 206, 206, 0.16)",
  darkShadow: "rgba(206, 206, 206, 0.90)",
  success: "#5DB65B",
  error: "#F9914E",
  messageBox: "#F7F7FC",
  blackBackground: "#18181B",
  gray: '#5A5B61',
  start: "#6D62F1",
  profit: "#665DDB",
  grayBackground: "#F8FAFC",
  readonlyBackground: "#f2f2f2",
}

const letterColors:any = {
  "1": "#FF5733",
  "2": "#33FF57",
  "3": "#3357FF",
  "4": "#FF33A1",
  "5": "#A133FF",
  "6": "#33FFF6",
  "7": "#FF8C33",
  "8": "#8C33FF",
  "9": "#33A1FF",
  "10": "#FF336E",
  "11": "#33FFA1",
  "12": "#FFA133",
  "13": "#A1FF33",
  "14": "#5733FF",
  "15": "#FF33D1",
  "16": "#33FFD1",
  "17": "#D133FF",
  "18": "#FF3333",
  "19": "#33FF8C",
  "20": "#FFC733",
  "21": "#33C7FF",
  "22": "#FF33C7",
  "23": "#A1FF8C",
  "24": "#FF8CA1",
  "25": "#8CA1FF",
  "26": "#8CFF33"
};

console.log(letterColors);


export { Colors,DarkColors,letterColors};
